import {Box} from "@chakra-ui/react";
import OrganizationServerTable from "./serversTable";
import {USER_SERVER} from "./constants";

const VmPersonalPricing = ({showHeader = true}: {showHeader?: boolean}) => {
  return (
    <Box id="dedicated-vm-minimum-10-user">
      <OrganizationServerTable {...USER_SERVER} showHeader={showHeader} />
    </Box>
  );
};

export default VmPersonalPricing;
